import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: '#F6F6F6',
    borderRadius: 4,
    padding: '16px 13px',
    marginTop: theme.spacing(1),
    display: 'flex',
    height: 99,
    justifyContent: 'center',
    alignItems: 'center',
  },
}))

function CartCard(props) {
  const classes = useStyles()
  return <div className={classes.card}>ไม่มีสินค้า</div>
}

export default CartCard
